<template>
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-md-6">
        <channels
          :channels="channels"
          :activeChannelTab="activeChannelTab"
          @onChangeTab="onChangeTab($event)"
          class="match-height"
        />
      </div>
      <div class="col-md-6">
        <channel-create class="match-height" />
      </div>
    </div>
  </div>
</template>

<script>
import Channels from '@/components/channel/Channels';
import ChannelCreate from '@/components/channel/ChannelCreate';

export default {
  name: 'ChannelDashboard',
  components: { Channels, ChannelCreate },
  props: {
    channels: {
      type: Array,
      default: () => [],
      required: true,
    },
    activeChannelTab: {
      type: String,
      default: 'activeChannels',
    },
  },
  methods: {
    onChangeTab(tab) {
      this.$emit('onChangeTab', { activeChannelTab: tab });
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/style/_variables_live.scss';

@keyframes fadeInUp {
  0% {
    opacity: 0;
    webkit-transform: translateY(20px);
    transform: translateY(20px);
  }
}
.channel-icon {
  margin-right: 0.8em;
  color: $white;

  &.channel-icon-fa-envelope {
    background-color: $kournikova;
    color: $scorpion;
  }

  &.channel-icon-fa-mobile {
    background-color: $cerulean;
  }

  &.channel-icon-fa-asterisk {
    background-color: $black;
  }

  &.channel-icon-fa-twitter {
    background-color: $dodge-blue;
  }

  &.channel-icon-fa-whatsapp {
    background-color: $emerald;
  }

  &.channel-icon-fa-instagram {
    background-color: $cerise-red;
  }

  &.channel-icon-fa-facebook {
    background-color: $chambray;
  }

  &.channel-icon-fa-wechat {
    background-color: $apple;
  }
}
.channel-activate,
.channel-deactivate {
  opacity: 0;
}
.channel-activate {
  color: $curious-blue;
}
.channel-deactivate {
  color: $mandy;
}
.channels-table {
  tr {
    &:hover {
      .channel-activate,
      .channel-deactivate {
        opacity: 1;
      }
    }
  }
}

.social-icon {
  float: left;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// ChannelDashboard.vue?77967c77